.cardList {
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding: 0.4rem 0.5rem 1rem;
}

.card {
	background: #ffffff;
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
	overflow: hidden;
	transition:
		box-shadow 0.15s ease,
		transform 0.15s ease;
	display: flex;
	flex-direction: column;
}

.card:hover {
	box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}

.cardHeader {
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	padding: 0.6rem 0.75rem;
	background: #f9fafb;
	border-bottom: 1px solid #eef2f7;
}

.cardSelect {
	display: flex;
	align-items: center;
	flex-shrink: 0;
	padding-top: 0.1rem;
}

.cardSummary {
	display: flex;
	flex-direction: column;
	gap: 0.3rem;
	flex: 1;
	min-width: 0;
}

.summaryItem {
	min-width: 0;
}

.cardActions {
	display: flex;
	align-items: center;
	margin-left: auto;
	flex-shrink: 0;
}

.cardBody {
	display: flex;
	flex-direction: column;
}

.cardRow {
	display: grid;
	grid-template-columns: minmax(6rem, 9rem) 1fr;
	gap: 0.6rem;
	padding: 0.5rem 0.75rem;
	border-bottom: 1px solid #f3f4f6;
	align-items: flex-start;
	min-width: 0;
}

.cardRow:last-child {
	border-bottom: none;
}

.cardLabel {
	font-size: 0.68rem;
	font-weight: 700;
	color: #6b7280;
	text-transform: uppercase;
	letter-spacing: 0.03em;
	padding-top: 0.2rem;
}

.cardValue {
	font-size: 0.82rem;
	color: #111827;
	min-width: 0;
	max-width: 100%;
	overflow-x: auto;
	word-break: break-word;
}

.cardValue::-webkit-scrollbar {
	height: 4px;
}

.cardValue::-webkit-scrollbar-thumb {
	background: #d1d5db;
	border-radius: 2px;
}

.emptyValue {
	color: #9ca3af;
}

.emptyWrapper {
	display: flex;
	justify-content: center;
	padding: 2rem 1rem;
}

@media (max-width: 480px) {
	.cardRow {
		grid-template-columns: 1fr;
		gap: 0.15rem;
		padding: 0.45rem 0.65rem;
	}
	.cardLabel {
		font-size: 0.62rem;
	}
	.cardHeader {
		padding: 0.55rem 0.65rem;
	}
}
